/**
 * Script before boot modules
 */
import { setZodLocale } from '@seedkit/vue/utils';
import { zodRu } from '@seedkit/vue/locales';

export default async function () {
  await setZodLocale(zodRu);
}
